import { render } from "./CourseOrderDetail.vue?vue&type=template&id=16808cdb&scoped=true"
import script from "./CourseOrderDetail.vue?vue&type=script&lang=js"
export * from "./CourseOrderDetail.vue?vue&type=script&lang=js"

import "./CourseOrderDetail.vue?vue&type=style&index=0&id=16808cdb&scoped=true&lang=css"

import exportComponent from "D:\\京欣医疗用户端\\login_init\\node_modules\\.pnpm\\vue-loader@16.8.3_@vue+compiler-sfc@3.4.31_vue@3.4.31_webpack@4.47.0\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16808cdb"]])

export default __exports__